import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import universalLocalStorage from "./utils/lib/universalLocalStorage";

const resources = {
  en: {
    translation: {},
  },
  fr: {
    translation: {
      MARRIED: "Mariée",
      SINGLE: "Célibataire",

      done: "Effectué",
      Done: "Effectué",
      Nickname: "Surnom",
      Email: "Email",
      Banned: "Banni",
      Gender: "Genre",
      "Marriage Status": "Situation matrimoniale",
      "Number Of Children": "Nombre d'enfants",
      Site: "Nom de code",
      "Site Codename": "Nom de code",
      "Profile Profile Image": "Image",
      "Registration Number": "Matricule",
      "Is Insured": "Assuré",
      "Is Active": "Actif",
      "Has Badge": "Badge",
      "Payment Type": "Type Virement",
      "Account Type": "Type de compte",
      "First Name": "Prénom",
      "Last Name": "Nom",
      "Date Of Birth": "Date de naissance",
      "Hiring Date": "Date d'embauche",
      "Contract End Date": "Fin du contrat",
      "Contract Type": "Type de contrat",
      "Employee Type": "Type d'employé",
      Employee: "Employé",
      employee: "Employé",
      "Phone Number": "Numéro de téléphone",
      "Profile Nickname": "Surnom",
      "Employee Responsibility": "Fonction",
      employeeResponsibility: "Fonction",
      Shift: "Shift",
      "Full Name": "Identité",
      Contracts: "Contrats",
      departDate: "Date de fin",
      "Depart Date": "Date de fin",
      "Contract End Date": "Date de fin",
      "Site Client Name": "Nom du client",
      "Site Place Name": "Nom de code",
      "Site Longitude": "Longitude du site",
      "Site Latitude": "Latitude du site",
      "Site Contacts": "Contacts du site",
      "Site Date Of Implementation": "Date de mise en œuvre du site",
      "Site Contracts": "Contrats du site",
      "Site Assistance": "Assistance du site",
      "Site Address Street": "Rue de l'adresse du site",
      "Site Direction To Follow": "Direction à suivre du site",
      "Site Is Active": "Actif",
      "Zone Name": "Zoulou",
      Zone: "Zoulou",
      "Zone Description": "Description de la zone",
      "Role Role Name": "Nom du rôle",
      "Role Description": "Description du rôle",
      "Role Profile Permissions": "Autorisations de profil du rôle",
      "Role Site Permissions": "Autorisations de site du rôle",
      "Role Role Permissions": "Autorisations de rôle du rôle",
      "Role Comments Permissions": "Autorisations de commentaires du rôle",
      Comments: "Commentaire",
      "Role Absence Permissions": "Autorisations d'absence du rôle",
      "Role Mistake Permission": "Autorisation d'erreur du rôle",
      "Role Vacation Permissions": "Autorisations de vacances du rôle",
      "Role Name": "Nom du rôle",
      "Client Name": "Nom du client",
      "Place Name": "Nom du lieu",
      Note: "Motif",
      Longitude: "Longitude",
      Latitude: "Latitude",
      Contacts: "Contacts",
      Contracts: "Contrats",

      Assistance: "Assistance",
      "Address Locality": "Commune",
      "Address Street": "Rue",
      "Direction To Follow": "Direction à suivre",
      "Special Instructions": "Instructions spéciales",
      "Start Date": "Date de début",
      "End Date": "Date de fin",
      "Is Justified": "Justifié",
      "Profile Account Type": "Type de compte",
      Response: "Type de reponse",
      Reason: "Motif",
      "Suspension Days": "Mise a pied",
      "Profile First Name": "Prénom ",
      "Profile Last Name": "Nom",
      "Profile Email": "Email",
      "Profile Banned": "Banni",
      "Profile Gender": "Genre",
      "Profile Registration Number": "Matricule",
      "Profile Is Insured": "Assuré",
      "Profile Is Active": "Actif",
      "Profile Has Badge": "Badge",
      "Profile Base Salary": "Salaire",
      "Base Salary": "Salaire",
      "Profile Cnps Number": "N°CNPS",
      "Cnps Number": "Numéro CNPS",
      "Profile Contract End Date": "Date de fin de contrat",
      "Profile Contract Type": "Type de contrat",
      "Profile Day Of Rest": "Jour de repos",
      "Day Of Rest": "Jour de repos",
      dayOfRest: "Jour de repos",
      "Profile Employee Responsibility": "Responsabilité",
      "Profile Hiring Date": "Date de recrutement",
      "Profile Payment Type": "Type de paiement",
      "Profile Phone Number": "Téléphone",
      "Profile Prime": "Prime",
      "Profile Shift": "Rotation",
      "Profile Date Of Birth": "Date de naissance",
      "Site Address Locality": "Adresse du site",
      "ite Special Instructions": "Instructions",
      "Role Comment Permissions": "Permissions de commentaire par rôle",
      "Role Zone Permissions": "Permissions de zone par rôle",
      "Role Dispute Permissions": "Permissions de gestion des litiges par rôle",
      //replacement user
      replacementUserRegistrationNumber: "Matricule du remplaçant",
      replacementUserFirstName: "Prénom du remplaçant",
      replacementUserLastName: "Nom du remplaçant",
      "Replacement User Registration Number": "Matricule du remplaçant",
      "Replacement User First Name": "Prénom du remplaçant",
      "Replacement User Last Name": "Nom du remplaçant",
    },
  },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources,
    lng: "en", // language to use, more information here: https://www.i18next.com/overview/configuration-options#languages-namespaces-resources
    // you can use the i18n.changeLanguage function to change the language manually: https://www.i18next.com/overview/api#changelanguage
    // if you're using a language detector, do not define the lng option

    interpolation: {
      escapeValue: false, // react already safes from xss
    },
  });

universalLocalStorage.getItem("langPreference").then((languagePreference) => {
  if (!languagePreference) languagePreference = "fr";

  console.log("using the lang", languagePreference);

  if (languagePreference) {
    i18n.changeLanguage(languagePreference);
  } else {
    i18n.changeLanguage();
  }
});

//forces the use of language detector

export default i18n;
